'use strict';

/**
 * UI Admin — suivi colis expédition (B2.4b3b).
 * Libellés métier commerçant ; aucun vocabulaire provider.
 */

import {
  expeditionShipmentStatusLabelMerchant,
  SHIPMENT_RANK,
} from '@clickorico/shared-domain/expeditionDisplayState';

export function expeditionShipmentStatusLabel(status) {
  if (status == null || status === '') return 'Suivi indisponible';
  const key = String(status).trim().toUpperCase();
  if (!Object.prototype.hasOwnProperty.call(SHIPMENT_RANK, key)) {
    return 'Suivi indisponible';
  }
  return expeditionShipmentStatusLabelMerchant(status) || 'Suivi indisponible';
}

export function canShowExpeditionTrackingPanel(commande) {
  if (!commande || commande.modeRetrait !== 'expedition') return false;
  return Boolean(commande.shipment?.id);
}

export function canSyncExpeditionTracking(commande) {
  if (!canShowExpeditionTrackingPanel(commande)) return false;
  const shipment = commande.shipment;
  if (!shipment.providerShipmentId) return false;
  return true;
}

export function expeditionCarrierFollowLinkLabel(carrier) {
  const name = String(carrier || '').trim();
  if (!name) return 'Suivre le colis';
  return `Suivre chez ${name}`;
}

export function expeditionDraftPreparationMessage(shipment) {
  if (!shipment) return 'Étiquette non créée';
  if (shipment.providerShipmentId) {
    return 'Expédition enregistrée — étiquette ou suivi à finaliser';
  }
  if (String(shipment.provider || '').toUpperCase() === 'BOXTAL') {
    return expeditionProviderCreateUncertainMessage();
  }
  return 'Étiquette non créée';
}

export function expeditionProviderCreateUncertainMessage() {
  return 'Création en cours ou incertaine — ne pas relancer';
}
